module.exports = __webpack_public_path__ + "fonts/roboto-all-900-italic.e6cbd387.woff2";